import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

export const SkeletonHead = () => {
  return (
    <Box data-testid="skeleton-head__container">
      <SkeletonComponent height="22px" width="100%" mb="8px" />
      <SkeletonComponent height="16px" width="40%" />
    </Box>
  );
};

export const SkeletonApprovalType = () => {
  const { t } = useTranslation('host-reschedule');
  return (
    <Box data-testid="skeleton-type__container">
      <TextBold mb="12px">
        {t('select_request_type')} <span>*</span>
      </TextBold>
      <Box className={styles['approval-type__input-tab--container']}>
        <SkeletonComponent height="30px" width="20%" />
        <SkeletonComponent height="30px" width="20%" />
      </Box>
      <SkeletonComponent height="13px" width="70%" mt="8px" />
    </Box>
  );
};

export const SkeletonChangeSchedule = () => {
  return (
    <Box data-testid="skeleton-schedule__container">
      <SkeletonComponent height="18px" width="50%" mb="12px" />
      <SkeletonComponent height="18px" width="25%" mb="6px" />
      <SkeletonComponent height="40px" width="100%" mb="12px" />
      <Box className={styles['change-host__host-account']}>
        <Box>
          <SkeletonComponent height="18px" width="25%" mb="6px" />
          <SkeletonComponent height="40px" width="50%" mb="12px" />
        </Box>
        <Box>
          <SkeletonComponent height="18px" width="25%" mb="6px" />
          <SkeletonComponent height="40px" width="50%" mb="12px" />
        </Box>
      </Box>
      <SkeletonComponent height="26px" width="100%" mt="12px" />
    </Box>
  );
};

export const SkeletonReason = () => {
  return (
    <Box data-testid="skeleton-reason__container">
      <Flex justifyContent={'space-between'}>
        <SkeletonComponent height="18px" width="30%" mb="12px" />
        <SkeletonComponent height="18px" width="10%" mb="12px" />
      </Flex>
      <SkeletonComponent height="110px" width="100%" mb="12px" />
    </Box>
  );
};

export const SkeletonUploadImage = () => {
  return (
    <Box data-testid="skeleton-upload__container">
      <SkeletonComponent height="18px" width="30%" mb="18px" />
      <SkeletonComponent height="36px" width="100%" mb="6px" />
      <SkeletonComponent height="163px" width="100%" mb="6px" />
    </Box>
  );
};
